import * as api from 'shared/models/api'

const FEATURED_PRODUCTS = 'FEATURED_PRODUCTS';
const init = {products: [], blogs: []};

export default function(state = init, action = {}) {
  switch (action.type) {
    case FEATURED_PRODUCTS:
      return {...state, products: action.products};
    default:
      return state;
  }
}

export function featuredProducts() {
  return dispatch => {
    api.getFeaturedProducts().then(result => {
      dispatch({type: 'FEATURED_PRODUCTS', products: result});
    })
  }
}



// WEBPACK FOOTER //
// ./shared/components/home/actions.js